export default "__VITE_ASSET__CFKG7kJb__"